<template>
  <section class="hngrow">
    <div class="hngrow__banner">
      <TopBanner :item="banner" class="_mb-16" />
    </div>
    <div class="info-block _mb-16">
      <div class="info-block__container">
        <div class="container _px-md-4">
          <div class="info-block__text">
            <!-- <div
              class="text-descr _fs-30 _lh-42 _fw-400 _mb-8 _fs-sm-24 _lh-sm-32"
            >
              Приглашаем вас воспользоваться новым инструментом обучения,
              разработанным специально для Независимых Партнёров Herbalife
             , которые хотят иметь доступ к обучающим материалам на
              своих мобильных устройствах
            </div> -->
          </div>
          <div class="info-block__content">
            <div
              class="info-block__content-title _fs-32 _lh-38 _fw-700 _mb-6 _fs-md-24 _lh-md-32"
            >
              {{ $t("pages.hngrow.subtitle") }}
            </div>
            <div class="info-block__content-container">
              <div
                class="info-block__content-redirect _py-10 _px-12 _py-sm-0 _px-sm-0"
              >
                <p
                  class="content-redirect__text _fs-30 _lh-42 _fw-400 _mb-8 _fs-sm-24 _lh-sm-32"
                  v-html="$t('pages.hngrow.desktop')"
                ></p>
                <AppBtn
                  @click.native="dataLayerPush()"
                  class="_py-4 _px-6 _fs-16 _lh-24 _fw-500"
                >
                  <div class="_tc-white">{{ $t("interface.video.go") }}</div>
                </AppBtn>
              </div>
              <div class="info-block__content-market">
                <div class="market-appstore">
                  <img
                    class="d-none d-xl-block"
                    :src="require('@/assets/img/hngrow/appstore.png')"
                    alt=""
                  />
                  <div @click="qrAppstoreClick()" class="d-xl-none">
                    <img
                      :src="require('@/assets/img/hngrow/appstore.png')"
                      alt=""
                    />
                  </div>
                </div>
                <div class="qr-code _mt-4">
                  <img
                    :src="require('@/assets/img/hngrow/appstore-qr.svg')"
                    alt=""
                  />
                </div>
              </div>
              <div class="info-block__content-market">
                <div class="market-gplay">
                  <img
                    class="d-none d-xl-block"
                    :src="require('@/assets/img/hngrow/gplay.png')"
                    alt=""
                  />
                  <div @click="qrGPClick()" class="d-xl-none">
                    <img
                      :src="require('@/assets/img/hngrow/gplay.png')"
                      alt=""
                    />
                  </div>
                </div>
                <div class="qr-code _mt-4">
                  <img
                    :src="require('@/assets/img/hngrow/gplay-qr.svg')"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hngrow-materials">
      <div class="container _py-16 _px-md-4 _px-sm-0">
        <div
          class="hngrow-materials__title _fs-32 _lh-38 _fw-700 _mb-6 _px-sm-4"
        >
          {{ $t("pages.hngrow.materials") }}
        </div>
        <div
          class="hngrow-materials__list d-grid row-1-1 gap-32 _mt-6"
          v-if="getHnGrowList !== null"
        >
          <VideoCard
            @like="like"
            @favorite="favorite"
            @downloadFile="downloadFile"
            @viewItem="viewItem"
            @setVideoProgress="setVideoProgress"
            v-for="(block, ind) in filteredList"
            :key="ind"
            :item="getTranslate(block)"
            :analyticEventPrefix="'grow_material'"
          >
          </VideoCard>
        </div>
        <div class="d-flex justify-center _mt-6" v-else>
          <Preloader />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AppBtn from "@/components/UI/buttons/AppBtn";
import VideoCard from "@/components/UI/cards/VideoCard";
import Preloader from "@/components/UI/Preloader";
import TopBanner from "@/components/UI/banners/TopBanner";
import download from "@/mixins/download";
import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo() {
    return { title: this.$t("interface.menu.hngrow") };
  },
  name: "HNGrow",
  components: {
    AppBtn,
    VideoCard,
    TopBanner,
    Preloader,
  },
  mixins: [download],
  data: () => ({}),
  computed: {
    ...mapGetters(["getHnGrowList"]),
    currentLocale() {
      return this.Trans.currentLocale;
    },
    filteredList() {
      if (this.$route.params.filtered) {
        return this.getHnGrowList.filter((el) => !el.view).length
          ? this.getHnGrowList.filter((el) => !el.view)
          : this.getHnGrowList;
      }
      return this.getHnGrowList;
    },
    banner() {
      return {
        title: this.$t("pages.hngrow.title"),
        descr: this.$t("pages.hngrow.description"),
        theme: "dark",
        images: [
          {
            src: require("@/assets/img/banners/hng/HNG-mob.jpg"),
            media: "(max-width: 540px)",
          },
          {
            src: require("@/assets/img/banners/hng/HNG-tab.jpg"),
            media: "(max-width: 1024px)",
          },
          {
            src: require("@/assets/img/banners/hng/HNG-1440.jpg"),
            media: "(max-width: 1440px)",
          },
          {
            src: require("@/assets/img/banners/hng/HNG-1920.jpg"),
            media: "(min-width: 1441px)",
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions([
      "fetchHnGrowList",
      "HnGrowSetVideoProgress",
      "HnGrowSetLike",
      "HnGrowSetFavorite",
      "HnGrowSetView",
      "SOCKET_SEND_MESSAGE",
    ]),
    dataLayerPush() {
      if (this.$gtm) {
        this.$gtm.push({
          event: "grow_version_myherbalife",
        });
      }
      window.open("https://www.myherbalife.com/ru-RU/training/courses/hng");
    },
    qrAppstoreClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: "grow_app_store",
        });
      }
      window.open("https://apps.apple.com/us/app/hn-grow/id1461914159");
    },
    qrGPClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: "grow_google_play",
        });
      }
      window.open(
        "https://play.google.com/store/apps/details?id=com.intuition.hle&amp;hl"
      );
    },
    getTranslate(item) {
      return {
        ...item,
        title: item.translates[0].title,
        description: item.translates[0].description,
        preview: item.translates[0].preview,
        file: item.translates[0].file || item.translates[0].file_link,
        file_size: item.translates[0].file_size,
        extras: item.translates[0].extras,
      };
    },
    async updateList() {
      await this.fetchHnGrowList(this.currentLocale);
    },
    async like(id) {
      await this.HnGrowSetLike(id);
      await this.updateList();
    },
    async favorite(id) {
      await this.HnGrowSetFavorite(id);
      await this.updateList();
    },
    async setVideoProgress(id, time) {
      await this.HnGrowSetVideoProgress({
        id: id,
        progress: Math.round(time),
      });
      await this.updateList();
    },
    async viewItem(id) {
      await this.HnGrowSetView(id);
      await this.updateList();
    },
  },
  async mounted() {
    await this.fetchHnGrowList(this.currentLocale);
    this.SOCKET_SEND_MESSAGE(
      JSON.stringify({
        action: "set_path",
        path: this.$router.resolve({
          name: this.$route.name.replace("Loc", ""),
        }).href,
      })
    );
  },
};
</script>

<style lang="scss" scoped>
.hngrow {
  .info-block {
    &__text {
      color: color(dark-grey);
    }
    &__content {
      &-container {
        display: grid;
        grid-template-columns: 592px 280px 280px;
        grid-gap: 32px;
        @media screen and (max-width: 1220px) {
          grid-template-columns: 1fr 1fr;
        }
        @media screen and (max-width: 743px) {
          grid-template-columns: 1fr;
        }
      }
      &-title {
        color: color(dark-grey);
      }
      &-redirect {
        width: 100%;
        background-color: color(light);
        border-radius: 16px;
        @media screen and (max-width: 1220px) {
          grid-column-start: 1;
          grid-column-end: 3;
        }
        @media screen and (max-width: 743px) {
          grid-column-start: 1;
          grid-column-end: 1;
          background-color: transparent;
        }
      }
      .content-redirect {
        &__text {
          color: color(dark-grey);
        }
      }
      &-market {
        width: 100%;
        padding: 42px 55px;
        border: 1px solid color(grey-second);
        border-radius: 16px;
        img {
          width: 100%;
        }
        @media screen and (max-width: 1220px) {
          border: none;
          padding: 0;
          .qr-code {
            display: none;
          }
        }
      }
    }
  }
  &-materials {
    background-color: color(light);
    .card-btn {
      display: flex;
      max-width: fit-content;
    }
    &__title {
      color: color(dark-grey);
    }
  }
  &__banner {
    background-color: #FFFACB;
  }

  .top-banner {
    max-width: 1920px;
    margin: 0 auto;
  }
}
</style>
